/**
 * 连尚读书app，jsapi demo
 */
import utils from "./utils";
const $win = window;
class WkReader {
  constructor() {
    this.wkr = $win.WKR;
    if (!this.wkr) {
      try {
        // throw 'not find wkr object';
        // let exception = new CommonException('not find wkr object', 1);
        // throw exception;
        throw new Error('not find wkr object');
      } catch (e) {
        console.log(e);
      }
    }
  }

  isClient () {
    return this.haveWkR() || this._haveMethod('webkit.messageHandlers.getDeviceId')
  }

  haveWkR () {
    this.wkr = $win.WKR;
    // alert('this.wkr'+this.wkr);
    if (this.wkr) {
      return true;
    }
    return false;
  }

  onReader (call) {

  }

  // 锦书获取Scheme
  getIntentScheme (callback) {
    if (this.haveWkR() && this.wkr.getIntentScheme) {
      const schemeValue = this.wkr.getIntentScheme();
      console.log(schemeValue, 'schemeValue - schemeValue');
      if (typeof callback === 'function') {
        callback(schemeValue);
      }
      return schemeValue;
    } else if (this._haveMethod('webkit.messageHandlers.getIntentScheme')){
      const methodName = '__getIntentScheme_callback__'
      $win[methodName] = function (schemeValue) {
        console.log(schemeValue, 'schemeValue - schemeValue');
        if (typeof callback === 'function') {
          callback(schemeValue || '');
        }
      };
      window.webkit.messageHandlers.getIntentScheme.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // 锦书吊起相册
  requestAlbumPermission () {
    if (this.haveWkR() && this.wkr.requestAlbumPermission) {
      console.log('有requestAlbumPermission方法');
      this.wkr.requestAlbumPermission();
      console.log(222555);
    } else if (this._haveMethod('webkit.messageHandlers.requestAlbumPermission')){
      console.log('IOS 有requestAlbumPermission方法')
      const methodName = '__requestAlbumPermission_callback__'
      window.webkit.messageHandlers.requestAlbumPermission.postMessage({ methodName: methodName });
    }
  }

  // 锦书跳转运势页面
  goFortune () {
    if (this.haveWkR() && this.wkr.goFortune) {
      console.log('有goFortune方法');
      this.wkr.goFortune();
    } else if (this._haveMethod('webkit.messageHandlers.goFortune')){
      console.log('IOS 有goFortune方法')
      const methodName = '__goFortune_callback__'
      window.webkit.messageHandlers.goFortune.postMessage({ methodName: methodName });
    }
  }

  // 锦书获取签到提醒状态
  checkCalender (strjson,callback) {
    if (this.haveWkR() && this.wkr.checkCalender) {
      console.log('有checkCalender方法');
      this.wkr.checkCalender(strjson);
    } else if (this._haveMethod('webkit.messageHandlers.checkCalender')){
      console.log('IOS 有checkCalender方法')
      const methodName = '__checkCalender_callback__'
      window.webkit.messageHandlers.checkCalender.postMessage({ methodName: methodName, strjson: strjson });
    }
  }

  // 设置日历
  setCalender (strjson,callback) {
    console.log(111);
    console.log('this.wkr',this.wkr)
    if (this.haveWkR() && this.wkr.setCalender) {
      console.log('存在setCalender调用激励视频方法方法')
      this.wkr.setCalender(strjson);
    }else if (this._haveMethod('webkit.messageHandlers.setCalender')) {
        console.log('走了ios方法 setCalender')
        const methodName = '__setCalender_callback__';
        window.webkit.messageHandlers.setCalender.postMessage({ methodName: methodName, strjson: strjson });
    }
  }

  // 删除日历
  delCalender (strjson,callback) {
    if (this.haveWkR() && this.wkr.delCalender) {
      console.log('存在delCalender')
      this.wkr.delCalender(strjson);
    }else if (this._haveMethod('webkit.messageHandlers.delCalender')) {
        console.log('走了ios方法 delCalender')
        const methodName = '__delCalender_callback__';
        window.webkit.messageHandlers.delCalender.postMessage({ methodName: methodName, strjson: strjson });
    }
  }

   // 锦书领取VIP同步客户端
   getExperienceVip () {
    if (this.haveWkR() && this.wkr.getExperienceVip) {
      console.log('有getExperienceVip方法');
      this.wkr.getExperienceVip();
    } else if (this._haveMethod('webkit.messageHandlers.getExperienceVip')){
      console.log('IOS 有getExperienceVip方法')
      const methodName = '__getExperienceVip_callback__'
      window.webkit.messageHandlers.getExperienceVip.postMessage({ methodName: methodName });
    }
  }

  // 锦书刷新免广告时长
  refreshExemptionTime () {
    if (this.haveWkR() && this.wkr.refreshExemptionTime) {
      console.log('有refreshExemptionTime方法');
      this.wkr.refreshExemptionTime();
    } else if (this._haveMethod('webkit.messageHandlers.refreshExemptionTime')){
      console.log('IOS 有refreshExemptionTime方法')
      const methodName = '__refreshExemptionTime_callback__'
      window.webkit.messageHandlers.refreshExemptionTime.postMessage({ methodName: methodName });
    }
  }

  // 锦书跳福利中心
  navigateDeeplink (url) {
    if (this.haveWkR() && this.wkr.navigateDeeplink) {
      console.log('有navigateDeeplink方法');
      this.wkr.navigateDeeplink(url);
    } else if (this._haveMethod('webkit.messageHandlers.navigateDeeplink')){
      console.log('IOS 有navigateDeeplink方法')
      const methodName = '__navigateDeeplink_callback__'
      window.webkit.messageHandlers.navigateDeeplink.postMessage({ methodName: methodName, url: url });
    } else {
      console.log('没有navigateDeeplink方法，走href')
      window.location.href = url
    }
  }

  // 锦书获取版本号
  jinGetAppVersoinCode (callback) {
    if (this.haveWkR() && this.wkr.getAppVersoinCode) {
      const AppVersoinCode = this.wkr.getAppVersoinCode();
      console.log(AppVersoinCode, 'getAppVersoinCode - appVersoinCode');
      if (typeof callback === 'function') {
        callback(AppVersoinCode);
      }
      return AppVersoinCode;
    } else if (this._haveMethod('webkit.messageHandlers.getAppVersoinCode')){
      const methodName = '__getAppVersoinCode_callback__'
      $win[methodName] = function (appVersoinCode) {
        console.log(appVersoinCode, 'getAppVersoinCode - appVersoinCode');
        if (typeof callback === 'function') {
          callback(appVersoinCode || '');
        }
      };
      window.webkit.messageHandlers.getAppVersoinCode.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // 锦书获取包名
  jinGetPackageName (callback) {
    if (this.haveWkR() && this.wkr.getPackageName) {
      const packageName = this.wkr.getPackageName();
      console.log(packageName, 'getPackageName - packageName');
      if (typeof callback === 'function') {
        callback(packageName);
      }
      return packageName;
    } else if (this._haveMethod('webkit.messageHandlers.getPackageName')){
      const methodName = '__getPackageName_callback__'
      $win[methodName] = function (packageName) {
        console.log(packageName, 'getPackageName - packageName');
        if (typeof callback === 'function') {
          callback(packageName || '');
        }
      };
      window.webkit.messageHandlers.getPackageName.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // 锦书获取渠道
  jinGetChannel (callback) {
    if (this.haveWkR() && this.wkr.getChannel) {
      const channel = this.wkr.getChannel();
      console.log(channel, 'getChannel - channel');
      if (typeof callback === 'function') {
        callback(channel);
      }
      return channel;
    } else if (this._haveMethod('webkit.messageHandlers.getChannel')){
      const methodName = '__getChannel_callback__'
      $win[methodName] = function (channel) {
        console.log(channel, 'getChannel - channel');
        if (typeof callback === 'function') {
          callback(channel || '');
        }
      };
      window.webkit.messageHandlers.getChannel.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // 锦书顶部返回
  isShowWebTop (callback) {
    if (this.haveWkR() && this.wkr.isShowBackArrow) {
      const isShowWeb = this.wkr.isShowBackArrow();
      console.log(isShowWeb, 'isShowBackArrow - channel');
      if (typeof callback === 'function') {
        callback(isShowWeb + '');
      }
      return isShowWeb + '';
    } else if (this._haveMethod('webkit.messageHandlers.isShowBackArrow')){
      const methodName = '__isShowBackArrow_callback__'
      $win[methodName] = function (isShowWeb) {
        console.log(isShowWeb || 'false', 'isShowBackArrow - channel');
        if (typeof callback === 'function') {
          callback(isShowWeb || 'false');
        }
      };
      window.webkit.messageHandlers.isShowBackArrow.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('false');
      }
      return '';
    }
  }

  // 锦书状态栏高度
  changeFullScreen (callback) {
    if (this.haveWkR() && this.wkr.isOpenFullScreen) {
      const topHiehgt = this.wkr.isOpenFullScreen(true);
      console.log('android isOpenFullScreen', topHiehgt, 'topHiehgt')
      if (typeof callback === 'function') {
        callback(topHiehgt);
      }
      return topHiehgt;
    } else if (this._haveMethod('webkit.messageHandlers.isOpenFullScreen')){
      console.log('IOS isOpenFullScreen')
      const methodName = '__isOpenFullScreen_callback__'
      $win[methodName] = function (topHiehgt) {
        console.log(topHiehgt, 'isOpenFullScreen - topHiehgt');
        if (typeof callback === 'function') {
          callback(topHiehgt || 50);
        }
      };
      window.webkit.messageHandlers.isOpenFullScreen.postMessage({ methodName: methodName });
    }  else {
      if (typeof callback === 'function') {
        callback(20);
      }
      return '';
    }
  }

  // 锦书关闭H5WEB
  finishActivity () {
    if (this.haveWkR() && this.wkr.finishActivity) {
      console.log('android finishActivity');
      this.wkr.finishActivity();
    } else if (this._haveMethod('webkit.messageHandlers.finishActivity')){
      const methodName = '__finishActivity_callback__'
      window.webkit.messageHandlers.finishActivity.postMessage({ methodName: methodName });
    }
  }

  // 锦书检查安卓登陆状态
  getIsLogin (callback) {
    let login = '';
    if (this.haveWkR() && this.wkr.isLogin) {
      login = this.wkr.isLogin();
      if (typeof callback === 'function') {
        callback(login + '' || 'false');
      }
      return login || false;
    } else if (this._haveMethod('webkit.messageHandlers.isLogin')) {
      const methodName = '__isLogin_callback__';
      $win[methodName] = function (login) {
        if (typeof callback === 'function') {
          callback(login || 'false');
        }
      };
      window.webkit.messageHandlers.isLogin.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('false');
      }
      return '';
    }
  }

  // 锦书获取ECPM值
  getCPEMNew (callback) {
    if (this.haveWkR() && this.wkr.getExtensionEcpmBySceneId) {
      const getExtensionEcpm = this.wkr.getExtensionEcpmBySceneId('60');
      if (typeof callback === 'function') {
        callback(getExtensionEcpm);
      }
      return getExtensionEcpm;
    } else if (this._haveMethod('webkit.messageHandlers.getExtensionEcpmBySceneId')){
      console.log('IOS 有getExtensionEcpmBySceneId方法')
      const methodName = '__getExtensionEcpmBySceneId_callback__'
      $win[methodName] = function (getExtensionEcpm) {
        console.log(getExtensionEcpm, 'getExtensionEcpm');
        if (typeof callback === 'function') {
          callback(getExtensionEcpm || '');
        }
      };
      window.webkit.messageHandlers.getExtensionEcpmBySceneId.postMessage({ methodName: methodName, sceneId: 60 });
    }  else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // 锦书金币掉落声音
  getCoinVoice () {
    if (this.haveWkR() && this.wkr.playGoldMusic) {
      console.log('有playGoldMusic方法');
      this.wkr.playGoldMusic();
    } else if (this._haveMethod('webkit.messageHandlers.playGoldMusic')){
      console.log('IOS 有playGoldMusic方法')
      const methodName = '__playGoldMusic_callback__'
      window.webkit.messageHandlers.playGoldMusic.postMessage({ methodName: methodName });
    }
  }

  // 锦书播放激励视频
  playH5CommonRewardVideo (prizetype, prizeid, use_ecpm, sceneId, callback) {
    console.log('进入播放视频方法');
    if (this.haveWkR() && this.wkr.playH5CommonRewardVideo) {
      console.log('有playH5CommonRewardVideo方法');
      console.log('激励视频调用成功');
      console.log(prizetype, 'prizetype');
      console.log(prizeid, 'prizeid');
      console.log(use_ecpm, 'use_ecpm');
      console.log(sceneId, 'sceneId');
      this.wkr.playH5CommonRewardVideo(Number(prizetype), Number(prizeid), Number(use_ecpm), sceneId);
    } else if (this._haveMethod('webkit.messageHandlers.playH5CommonRewardVideo')){
      console.log('IOS 有playH5CommonRewardVideo方法')
      console.log('激励视频调用成功');
      console.log(prizetype, 'prizetype');
      console.log(prizeid, 'prizeid');
      console.log(use_ecpm, 'use_ecpm');
      console.log(sceneId, 'sceneId');
      const methodName = '__playH5CommonRewardVideo_callback__'
      window.webkit.messageHandlers.playH5CommonRewardVideo.postMessage({ methodName: methodName, prizetype: Number(prizetype), prizeid: Number(prizeid), use_ecpm: Number(use_ecpm), sceneId: Number(sceneId) });
    }
  }

  // 锦书调用登录
  goToLogin () {
    if (this.haveWkR() && this.wkr.gotoLogin) {
      console.log('有gotoLogin方法');
      this.wkr.gotoLogin();
    } else if (this._haveMethod('webkit.messageHandlers.gotoLogin')){
      console.log('IOS 有gotoLogin方法')
      const methodName = '__gotoLogin_callback__'
      window.webkit.messageHandlers.gotoLogin.postMessage({ methodName: methodName });
    }
  }

  // 锦书跳转听书书架
  goAudioShelf () {
    if (this.haveWkR() && this.wkr.goAudioShelf) {
      console.log('有goAudioShelf方法');
      this.wkr.goAudioShelf();
    } else if (this._haveMethod('webkit.messageHandlers.goAudioShelf')){
      console.log('IOS 有goAudioShelf方法')
      const methodName = '__goAudioShelf_callback__'
      window.webkit.messageHandlers.goAudioShelf.postMessage({ methodName: methodName });
    }
  }

  // 锦书跳转书架
  goShelf () {
    if (this.haveWkR() && this.wkr.goShelf) {
      console.log('有goShelf方法');
      this.wkr.goShelf();
    } else if (this._haveMethod('webkit.messageHandlers.goShelf')){
      console.log('IOS 有goShelf方法')
      const methodName = '__goShelf_callback__'
      window.webkit.messageHandlers.goShelf.postMessage({ methodName: methodName });
    }
  }

  // 锦书跳转书架，书架为空跳首页
  goShelfIfEmptyGoMain () {
    if (this.haveWkR() && this.wkr.goShelfIfEmptyGoMain) {
      console.log('有goShelfIfEmptyGoMain方法');
      this.wkr.goShelfIfEmptyGoMain();
    } else if (this._haveMethod('webkit.messageHandlers.goShelfIfEmptyGoMain')){
      console.log('IOS 有goShelfIfEmptyGoMain方法')
      const methodName = '__goShelfIfEmptyGoMain_callback__'
      window.webkit.messageHandlers.goShelfIfEmptyGoMain.postMessage({ methodName: methodName });
    }
  }

  // 锦书跳转短剧书架
  goVideoShelf () {
    if (this.haveWkR() && this.wkr.goVideoShelf) {
      console.log('有goVideoShelf方法');
      this.wkr.goVideoShelf();
    } else if (this._haveMethod('webkit.messageHandlers.goVideoShelf')){
      console.log('IOS 有goVideoShelf方法')
      const methodName = '__goVideoShelf_callback__'
      window.webkit.messageHandlers.goVideoShelf.postMessage({ methodName: methodName });
    }
  }

  // 锦书跳转书籍阅读器
  goBookDetail (bookid) {
    if (this.haveWkR() && this.wkr.goBookDetail) {
      console.log('有goBookDetail方法');
      this.wkr.goBookDetail(bookid);
    } else if (this._haveMethod('webkit.messageHandlers.goBookDetail')){
      console.log('IOS 有goBookDetail方法')
      const methodName = '__goBookDetail_callback__'
      window.webkit.messageHandlers.goBookDetail.postMessage({ methodName: methodName, bookid: Number(bookid) });
    }
  }

  // 锦书分享
  shareUrlToWx (task_id, url, bookid, share_title, share_description, share_cover) {
    if (this.haveWkR() && this.wkr.shareUrlToWx) {
      console.log('有shareUrlToWx方法');
      console.log(task_id, 'task_id');
      console.log(url, 'url');
      console.log(bookid, 'bookid');
      console.log(share_title, 'share_title');
      console.log(share_description, 'share_description');
      console.log(share_cover, 'share_cover');
      this.wkr.shareUrlToWx(Number(task_id), url, Number(bookid), share_title, share_description, share_cover);
    } else if (this._haveMethod('webkit.messageHandlers.shareUrlToWx')){
      console.log('IOS 有shareUrlToWx方法')
      console.log(task_id, 'task_id');
      console.log(url, 'url');
      console.log(bookid, 'bookid');
      console.log(share_title, 'share_title');
      console.log(share_description, 'share_description');
      console.log(share_cover, 'share_cover');
      const methodName = '__shareUrlToWx_callback__'
      window.webkit.messageHandlers.shareUrlToWx.postMessage({ methodName: methodName, task_id: Number(task_id), url: url, bookid: Number(bookid), share_title: share_title, share_description: share_description, share_cover: share_cover });
    }
  }



  // 锦书过审使用
  isShowTheater (callback) {
    if (this.haveWkR()) {
      if (typeof callback === 'function') {
        callback('true');
      }
      return 'true';
    } else if (this._haveMethod('webkit.messageHandlers.isShowTheater')){
      const methodName = '__isShowTheater_callback__'
      $win[methodName] = function (isShowWeb) {
        console.log(isShowWeb || 'true', 'isShowTheater - channel');
        if (typeof callback === 'function') {
          callback(isShowWeb || 'true');
        }
      };
      window.webkit.messageHandlers.isShowTheater.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('true');
      }
      return '';
    }
  }

  // 锦书过审使用
  isShowShare (callback) {
    if (this.haveWkR()) {
      if (typeof callback === 'function') {
        callback('true');
      }
      return 'true';
    } else if (this._haveMethod('webkit.messageHandlers.isShowShare')){
      const methodName = '__isShowShare_callback__'
      $win[methodName] = function (isShowWeb) {
        console.log(isShowWeb || 'true', 'isShowShare - channel');
        if (typeof callback === 'function') {
          callback(isShowWeb || 'true');
        }
      };
      window.webkit.messageHandlers.isShowShare.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('true');
      }
      return '';
    }
  }








































  /**
   * 获取安装app列表
   * @param {*} param0
   */
  getInstallAppList () {
    //  const demoJson = "[\"com.snda.wifilocating\",\"com.snda.wifilocating\", \"com.moji.mjweather\"]";
    const demoJson = "[]";
    let listData = '';
    if (!this.haveWkR()) {
      listData = demoJson;
      return JSON.parse(listData);
    }
    if (!this.wkr.getInstalledApplications) {
      return JSON.parse(demoJson);
    }
    let list = this.wkr.getInstalledApplications();
    // alert(list);
    if (!list) {
      return JSON.parse(demoJson);
    }
    let jplist = JSON.parse(list);
    // alert(jplist);
    if (jplist.map) {
      return jplist;
    }
    return JSON.parse(demoJson);
  }



  /**
   * 返回包名
   */
  getPackageName (callback) {

    if (this.haveWkR()) {
      return this.getAndroidPKGName(callback);
    } else if (this._haveMethod('webkit.messageHandlers.getPKGName')) {
      return this.getiOSPKGName(callback);
    }
    if (typeof callback === 'function') {
      callback('');
    }
    return '';
  }

    /**
   * 返回渠道
   */
     getChannel (callback) {

      if (this.haveWkR()) {
        return this.getChannelName(callback);
      }
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    getChannelName (callback) {
      if (this.haveWkR() && this.wkr.getChannel) {
        const channel = this.wkr.getChannel();
        if (typeof callback === 'function') {
          callback(channel);
        }
        return channel;
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    }



    getCPEM (callback) {
      if (this.haveWkR()) {
        return this.getCPEMValue(callback);
      }
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    getCPEMValue (callback) {
      if (this.haveWkR() && this.wkr.getExtensionEcpm) {
        const getExtensionEcpm = this.wkr.getExtensionEcpm();
        if (typeof callback === 'function') {
          callback(getExtensionEcpm);
        }
        return getExtensionEcpm;
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    }

  getAndroidPKGName (callback) {
    if (this.haveWkR() && this.wkr.getPackageName) {
      const PackageName = this.wkr.getPackageName();
      if (typeof callback === 'function') {
        callback(PackageName);
      }
      return PackageName;
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }
  getEnableXm () {
    if (this.haveWkR() && this.wkr.getEnableXm) {
      console.log('有getEnableXm方法');
      const enableXm = this.wkr.getEnableXm();
      return enableXm;
    } else {
      return '';
    }
  }
  reportExposureOrClick (bool, id) {
    if (this.haveWkR() && this.wkr.reportExposureOrClick) {
      console.log('有reportExposureOrClick方法');
      this.wkr.reportExposureOrClick(bool, id);
    }
  }
  getiOSPKGName (callback) {
    const methodName = '__getPKGName_callback__';
    if (!$win[methodName]) {
      $win[methodName] = function (PKGName) {
        const name = PKGName || '';
        if (typeof callback === 'function') {
          callback(name);
        }
        return name;
      };
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    window.webkit.messageHandlers.getPKGName.postMessage({ methodName: methodName });
  }

  /**
   * 返回设备ID
   */
  getDeviceId (callback) {
    if (this.haveWkR()) {
      return this.getAndroidDeviceId(callback);
    } else if (this._haveMethod('webkit.messageHandlers.getDeviceId')) {
      this.getiOSDeviceId(callback);
      return '';
    }
    if (typeof callback === 'function') {
      callback('');
    }
    return '';
  }
  // android机获取DeviceId,同步
  getAndroidDeviceId (callback) {

    if (this.haveWkR() && this.wkr.getDeviceId) {
      const did = this.wkr.getDeviceId();
      // alert(JSON.stringify({did}));
      if (typeof callback === 'function') {
        callback(did);
      }
      return did;
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  /**
   * ios获到getDeviceId,异步
   */
  getiOSDeviceId (callback) {
    const methodName = '__getDeviceId_callback__';
    if (!$win[methodName]) {
      $win[methodName] = function (DeviceId) {
        const did = DeviceId || '';
        if (typeof callback === 'function') {
          callback(did);
        }
      };
    }

    window.webkit.messageHandlers.getDeviceId.postMessage({ methodName: methodName });
  }

  /**
   * 返回机器IMEI
   */
  getIMEI () {
    if (!this.haveWkR()) {
      return '';
    }
    // alert(this.wkr.getImei);
    if (!this.wkr.getImei) {
      return '';
    }
    return this.wkr.getImei() || '';
  }

  // 返回用户的ID
  getUserId (callback) {
    if (this.haveWkR()) {
      return this.getAndroidUserId(callback);
    } else if (this._haveMethod('webkit.messageHandlers.getUserId')) {
      return this.getIOSUserId(callback);
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  getAndroidUserId (callback) {
    let uid = '';
    if (this.haveWkR() && this.wkr.getUserId) {
      uid = this.wkr.getUserId();
      // alert(JSON.stringify({uid}));
    }
    if (typeof callback === 'function') {
      callback(uid);
    }
    return uid;
  }

  getIOSUserId (callback) {
    const methodName = '__getUserId_callback__';
    if (!$win[methodName]) {
      $win[methodName] = function (DeviceId) {
        const did = DeviceId || '';
        if (typeof callback === 'function') {
          callback(did);
        }
      };
    }

    window.webkit.messageHandlers.getUserId.postMessage({ methodName: methodName });
  }

  // 获取版本号
  getAppVersoinCode (callback) {
    if (this.haveWkR()) {
      return this.getAndroidVersoinCode(callback);
    } else if (this._haveMethod('webkit.messageHandlers.getVesionCode')) {
      this.getiOSAppVersoinCode(callback);
      return '';
    }
    if (typeof callback === 'function') {
      callback('');
    }
    return '';
  }


  loadBottomAd () {
    if (this.haveWkR() && this.wkr.loadBottomAd) {
      this.wkr.loadBottomAd();
    }
  }

  showBottomAd () {
    if (this.haveWkR() && this.wkr.showBottomAd) {
      this.wkr.showBottomAd();
    }
  }

  getAndroidVersoinCode (callback) {
    if (this.haveWkR() && this.wkr.getAppVersoinCode) {
      const AppVersoinCode = this.wkr.getAppVersoinCode();
      if (typeof callback === 'function') {
        callback(AppVersoinCode);
      }
      return AppVersoinCode;
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }
  getiOSAppVersoinCode (callback) {
    $win['iOSAppVersoinCodecallback'] = callback
    const methodName = '__getVesionCode_callback__';
    if (!$win[methodName]) {
      $win[methodName] = function (VesionCode) {
        if (typeof $win['iOSAppVersoinCodecallback'] === 'function') {
          $win['iOSAppVersoinCodecallback'](VesionCode || '');
        }
      };
    }

    window.webkit.messageHandlers.getVesionCode.postMessage({ methodName: methodName });
  }

  getChargeResult (request_code, callback) {
    if (this.haveWkR() && this.wkr.getChargeResult) {
      const result = this.wkr.getChargeResult(request_code);
      if (typeof callback === 'function') {
        callback(result);
      }
      return result;
    }
  }

  getSignResult (request_code, callback) {
    if (this.haveWkR() && this.wkr.getSignResult) {
      const result = this.wkr.getSignResult(request_code);
      if (typeof callback === 'function') {
        callback(result);
      }
      return result;
    }
  }

  isSupportDeepCharge (callback) {
    if (this.haveWkR() && this.wkr.isSupportDeepCharge) {
      const result = this.wkr.isSupportDeepCharge();
      if (typeof callback === 'function') {
        callback(result);
      }
      return result;
    }
  }

  // 通过客户端获取服务端 隐私协议 开关是否打开 >191110
  checkPrivacyAgreementBeforeCharge () {
    if (this.haveWkR() && this.wkr.checkPrivacyAgreementBeforeCharge && this.wkr.isHasAgreePrivacyAgreement) {
      let result = this.wkr.checkPrivacyAgreementBeforeCharge();
      if (result) {
        // 开关打开了  获取用户是否已同意隐私协议 >191110
        let res = this.wkr.isHasAgreePrivacyAgreement();
        return res  // res true 用户已同意，false 用户不同意
      } else {
        // 开关没打开，不用管是都同意
        return true;
      }
    } else {
      // 老版本没有方法，不用管是否同意
      return true
    }
  }

  // 通过客户端获取服务端 隐私协议 开关是否打开 >191110
  setHasAgreePrivacyAgreement (flag) {
    if (this.haveWkR() && this.wkr.setHasAgreePrivacyAgreement) {
      this.wkr.setHasAgreePrivacyAgreement(flag);
    }
  }


  getIOSNeedRefresh (callback) {  // H5直接掉IOS支付，之后检查是否成功
    if (this._haveMethod('webkit.messageHandlers.getNeedRefresh')) {
      const methodName = '__getNeedRefresh_callback__';
      if (!$win[methodName]) {
        $win[methodName] = function (NeedRefresh) {
          if (typeof callback === 'function') {
            callback(NeedRefresh || '');
          }
        };
      }

      window.webkit.messageHandlers.getNeedRefresh.postMessage({ methodName: methodName });
    }
  }

  // 调用IOS客户端支付完成后，获取订单号
  getOrderId (callback) {  // H5直接掉IOS支付，之后检查是否成功
    if (this._haveMethod('webkit.messageHandlers.getOrderId')) {
      const methodName = '__getOrderId_callback__';
      if (!$win[methodName]) {
        $win[methodName] = function (OrderId) {
          if (typeof callback === 'function') {
            callback(OrderId || '');
          }
        };
      }

      window.webkit.messageHandlers.getOrderId.postMessage({ methodName: methodName });
    } else {
      console.log('没有webkit.messageHandlers.getOrderId方法')
    }
  }

  _haveMethod (methods_str, root = $win) {
    let methods = methods_str.split('.');
    let flag = true;
    let rootObj = root;
    methods.forEach(item => {
      if (rootObj[item]) {
        rootObj = rootObj[item];
      } else {
        flag = false;
      }
    });
    return flag;
  }


  // 刷新金额接口
  refreshAccountInfo () {
    if (this.haveWkR() && this.wkr.refreshAccountInfo) {
      return this.wkr.refreshAccountInfo();
    } else if (this._haveMethod('webkit.messageHandlers.refreshAccount')) {
      console.log('走了ios方法')
      window.webkit.messageHandlers.refreshAccount.postMessage({ methodName: 'refreshAccount' });
    } else {
      console.log('无方法')
    }
  }

  // 获取支付方式
  getUserPayConfig () {
    //获取客户端默认支付方式接口方法getDefaultPayWay，返回值”alipay” : 支付宝、”wechat” : 微信、”wifi” : wifi钱包，异常则返回空字符串””，190820版本后的版本可支持
    if (this.haveWkR() && this.wkr.getDefaultPayWay) {
      return this.wkr.getDefaultPayWay();
    }
    return ''
  }

  // 设置本地分享
  setShareData (dataString) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setShareData) {
      return;
    }
    return this.wkr.setShareData(dataString);
  }
  /**
   * 是否显示分享按钮
   * @param {*} type 0为隐藏，1为显示
   */
  setShareShowType (type = 0) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setShareShowType) {
      return;
    }
    type = parseInt(type);
    return this.wkr.setShareShowType(type);
  }

  setPageCode (code) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setPageCode) {
      return;
    }
    this.wkr.setPageCode(code);
  }

  setToolBarPosCode (code) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setToolBarPosCode) {
      return;
    }
    this.wkr.setToolBarPosCode(code);
  }

  setShareBtnItemCode (code) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setShareBtnItemCode) {
      return;
    }
    this.wkr.setShareBtnItemCode(code);
  }





  // 获取安卓登陆toekn等信息
  getLoginInfo (callback) {
    let loginInfo = '';
    if (this.haveWkR() && this.wkr.getLoginInfo) {
      loginInfo = this.wkr.getLoginInfo();
    } else {
      console.log('没有getLoginInfo方法')
    }
    if (typeof callback === 'function') {
      callback(loginInfo);
    }
    return loginInfo;
  }


  // 告诉客户端抽奖抽到了vip，用于打点自定义事件
  vipActivateByLottery (itemcode, vipdays) {
    if (this.haveWkR() && this.wkr.vipActivateByLottery) {
      this.wkr.vipActivateByLottery(itemcode, vipdays);
    } else {
      console.log('没有vipActivateByLottery方法')
    }
  }

  // 获取 h5_token_key
  getTokenkeyWithH5 (callback) {
    if (this.haveWkR() && this.wkr.getTokenkeyWithH5) {
      let token_key = this.wkr.getTokenkeyWithH5()
      console.log(token_key, 'token_key_and');
      // console.log('有getTokenkeyWithH5方法', token_key)
      if (typeof callback === 'function') {
        callback(token_key);
      }
      return token_key;
    } else if (this._haveMethod('webkit.messageHandlers.getTokenkeyWithH5')){
      console.log('IOS 有getTokenkeyWithH5方法')
      const methodName = '__getTokenkeyWithH5_callback__'
      $win[methodName] = function (token_key) {
        console.log(token_key, 'token_key_ios');
        if (typeof callback === 'function') {
          callback(token_key || '');
        }
      };
      window.webkit.messageHandlers.getTokenkeyWithH5.postMessage({ methodName: methodName });
    } else{

      console.log('没有getTokenkeyWithH5方法， 从url拿，一般用于本地开发使用')
      let token_key = utils.getUrlParam('token_key')
      if (typeof callback === 'function') {
        callback(token_key || '');
      }
      return token_key || ''
    }
  }

  // 跳转客户端任何页面，主要用于tab
  goToPage (url) {
    if (this.haveWkR() && this.wkr.gotoMain) {
      let res = this.wkr.gotoMain(url);
      if (!res) {
        console.log('gotoMain失败，走navigateDeeplink', url)
        this.navigateDeeplink(url)
      }
    } else {
      //ios无gotoMain（跳转书城首页的）方法
      console.log('非Android无gotoMain，走navigateDeeplink', url)
      this.navigateDeeplink(url)
    }
  }

  // 获取打点数据
  BuildEventParams () {
    let report = ''
    if (this.haveWkR() && this.wkr.buildEventParams) {
      report = this.wkr.buildEventParams();
    } else {
      report = ''
    }
    return report
  }

  // 获取当前环境 188还是246
  getHost (callback) {
    //通过客户端环境获取对应接口API的域名，http:// 格式，最后没有/，记得把https
    if (this.haveWkR() && this.wkr.getHost) {
      let host = this.wkr.getHost();
      console.log('host', host)
      if (typeof callback === 'function') {
        callback(host);
      }
      return host
    } else if (this._haveMethod('webkit.messageHandlers.getHost')) {
      const methodName = '__getHost_callback__'
      $win[methodName] = function (host) {
        console.log('host', host)
        if (typeof callback === 'function') {
          callback(host || '');
        }
      };

      window.webkit.messageHandlers.getHost.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // showLoading
  showLoading () {
    if (this.haveWkR() && this.wkr.showLoading) {
      console.log('有showLoading')
      this.wkr.showLoading();
    } else if (this._haveMethod('webkit.messageHandlers.showLoading')) {
      // window.webkit.messageHandlers.showLoading.postMessage();
    }
  }
  // hideLoading
  hideLoading () {
    if (this.haveWkR() && this.wkr.hideLoading) {
      this.wkr.hideLoading();
    } else if (this._haveMethod('webkit.messageHandlers.hideLoading')) {
      // window.webkit.messageHandlers.hideLoading.postMessage();
    }
  }

  // closeWebView 关闭当前webview，code暂时没用，但是必须传
  closeWebView (code) {
    if (this.haveWkR() && this.wkr.closeWebView) {
      console.log('存在closeWebView方法')
      this.wkr.closeWebView(code);
    } else if (this._haveMethod('webkit.messageHandlers.closeWebView')) {
      window.webkit.messageHandlers.closeWebView.postMessage();
    }
  }


  showToast (str) {
    if (this.haveWkR() && this.wkr.showToast) {
      console.log('存在showToast方法')
      this.wkr.showToast(str);
    } else if (this._haveMethod('webkit.messageHandlers.showToast')) {
      window.webkit.messageHandlers.showToast.postMessage();
    }
  }

  // 告知客户端一些消息 {key: get_vip_result, value: "{"vip":1}"}
  notifyApp (str) {
    if (this.haveWkR() && this.wkr.notifyApp) {
      console.log('存在notifyApp方法')
      this.wkr.notifyApp(str);
    } else if (this._haveMethod('webkit.messageHandlers.notifyApp')) {
      window.webkit.messageHandlers.notifyApp.postMessage();
    }
  }



  // 调用微信分享，传base64图片
  sharePicToWx (data) {
    if (this.haveWkR() && this.wkr.shareImgToWx) {
      console.log('shareImgToWx存在')
      this.wkr.shareImgToWx(data)
    } else if (this._haveMethod('webkit.messageHandlers.getEarnShare')) {
      let post_data = ''
      let index = data.indexOf('base64,')
      if (index > -1) {
        post_data = data.slice(index + 7)
      }
      window.webkit.messageHandlers.getEarnShare.postMessage(post_data);
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // 读书SDK分享到连信
  shareLinkToLxFriend (title, desc, linkurl, iconurl) {
    if (this.haveWkR() && this.wkr.shareLinkToLxFriend) {
      console.log('shareLinkToLxFriend存在')
      return this.wkr.shareLinkToLxFriend(title, desc, linkurl, iconurl)
    } else {
      return '';
    }
  }

  // 读书SDK分享到连信朋友圈
  shareLinkToLxMoments (title, linkurl, iconurl) {
    if (this.haveWkR() && this.wkr.shareLinkToLxMoments) {
      console.log('shareLinkToLxMoments存在')
      return this.wkr.shareLinkToLxMoments(title, linkurl, iconurl)
    } else {
      return '';
    }
  }

  // 大转盘的激励视频播放
  playTime () {
    if (this.haveWkR() && this.wkr.playTime) {
      console.log('存在playTime调用激励视频方法方法')
      this.wkr.playTime();
    }
  }

  // 通用的激励视频播放
  playRewardVideo (strjson,callback) {
    console.log('this.wkr',this.wkr)
    if (this.haveWkR() && this.wkr.playRewardVideo) {
      console.log('存在playRewardVideo调用激励视频方法方法')
      this.wkr.playRewardVideo(strjson);
    }else if (this._haveMethod('webkit.messageHandlers.playRewardVideo')) {
        console.log('走了ios方法')
        const methodName = '__playRewardVideo_callback__';
        $win[methodName] = function (code) {
            console.log('code',code)
            if (typeof callback === 'function') {
                callback(code || false);
            }
        };
        window.webkit.messageHandlers.playRewardVideo.postMessage(strjson);
    } else {
        callback && callback('')
      console.log('没有playRewardVideo方法')
        return ''
    }
  }

  // 通用的激励视频播放1
  playRewardVideoIphone (strjson,callback) {
    console.log('this.wkr',this.wkr)
    if (this.haveWkR() && this.wkr.playRewardVideo) {
      console.log('存在playRewardVideo调用激励视频方法方法')
      this.wkr.playRewardVideo(strjson);
    }else if (this._haveMethod('webkit.messageHandlers.playRewardVideo')) {
        window.webkit.messageHandlers.playRewardVideo.postMessage(strjson);
    } else {
        callback && callback('')
      console.log('没有playRewardVideo方法')
        return ''
    }
  }

  // 免广告激励视频播放
  cacheRewardVideo (strjson,callback) {
    if (this.haveWkR() && this.wkr.showCacheRewardVideo) {
      console.log('showCacheRewardVideo')
      this.wkr.showCacheRewardVideo(strjson);
    }else if (this._haveMethod('webkit.messageHandlers.showCacheRewardVideo')) {
        console.log('走了ios方法')
        const methodName = '__showCacheRewardVideo_callback__';
        $win[methodName] = function (code) {
            console.log('code',code)
            if (typeof callback === 'function') {
                callback(code || false);
            }
        };
        window.webkit.messageHandlers.showCacheRewardVideo.postMessage(strjson);
    } else {
        callback && callback('')
      console.log('showCacheRewardVideoaaa')
        return ''
    }
  }

  playExtensionVideo (prizetype, prizeid, use_ecpm, callback) {
    if (this.haveWkR() && this.wkr.playExtensionVideo) {
      console.log('存在playExtensionVideo调用激励视频方法方法')
      console.log(prizetype, prizeid, use_ecpm, '值');
      this.wkr.playExtensionVideo(Number(prizetype), Number(prizeid), Number(use_ecpm));
    } else {
      callback && callback('')
      console.log('没有playRewardVideo方法')
        return ''
    }
  }



  playTtsExtensionVideo (prizetype, prizeid, use_ecpm, callback) {
    if (this.haveWkR() && this.wkr.playTtsExtensionVideo) {
      console.log('存在playTtsExtensionVideo调用激励视频方法方法')
      console.log(prizetype, prizeid, use_ecpm, '值');
      this.wkr.playTtsExtensionVideo(Number(prizetype), Number(prizeid), Number(use_ecpm));
    } else {
      callback && callback('')
      console.log('没有playRewardVideo方法')
        return ''
    }
  }

  /**
   * 获取广告视频
   */
   getRewardVideo () {
     console.log('开始');
   if (this.haveWkR() && this.wkr.loadCacheRewardVideo) {
     console.log('开始调用loadCacheRewardVideo');
     this.wkr.loadCacheRewardVideo();
   }
 }

 /**
   * 取消刷新按钮
   */
  exitReshed (val) {
  if (this.haveWkR() && this.wkr.setRefreshBtn) {
    this.wkr.setRefreshBtn(val);
  }
}




  // ios跳转页面
  goPage (url) {
    if (utils.isAndroid()) {
      window.open(url, '_blank')
    } else {
      if (this._haveMethod('webkit.messageHandlers.openPage')) {
        window.webkit.messageHandlers.openPage.postMessage({ methodName: 'openPage', url: url });
      }
    }
  }

  // ios跳转页面
  goPageOn (url) {
    console.log(url);
    if (utils.isAndroid()) {
      console.log(2);
      location.href = url
    } else {
      if (this._haveMethod('webkit.messageHandlers.openPage')) {
        window.webkit.messageHandlers.openPage.postMessage({ methodName: 'openPage', url: url });
      }
    }
  }






  // 修改安卓状态栏配置
  changeFullScreenHidden (callback) {

    if (this.haveWkR()) {
      return this.changeAndroidFullScreenHidden(callback);
    }
    if (typeof callback === 'function') {
      callback('');
    }
    return '';
  }

  changeAndroidFullScreenHidden (callback) {
    if (this.haveWkR() && this.wkr.isOpenFullScreen) {
      const isOpenFullScreen = this.wkr.isOpenFullScreen(false);
      if (typeof callback === 'function') {
        callback(isOpenFullScreen);
      }
      return isOpenFullScreen;
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }


   /**
   * 返回渠道
   */
    getDeepLink (callback) {

      if (this.haveWkR()) {
        return this.getWelfareCenterTabDeeplink(callback);
      }
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    getWelfareCenterTabDeeplink (callback) {
      if (this.haveWkR() && this.wkr.getWelfareCenterTabDeeplink) {
        const deepLink = this.wkr.getWelfareCenterTabDeeplink();
        if (typeof callback === 'function') {
          callback(deepLink);
        }
        return deepLink;
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    }

    // 跳转金币商城
    enterCoinStore (channel) {
    if (this.haveWkR() && this.wkr.enterCoinStore) {
      this.wkr.enterCoinStore(channel);
    }
  }

   // 跳转
   enterAdxWithdraw () {
    if (this.haveWkR() && this.wkr.enterAdxWithdraw) {
      this.wkr.enterAdxWithdraw();
    }
  }

   /**
   * 展示顶部title
   */
    isShowWebTitle (callback) {

      if (this.haveWkR()) {
        return this.getisShowWebTitle(callback);
      }
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    getisShowWebTitle (callback) {
      if (this.haveWkR() && this.wkr.isShowWebTitle) {
        const showWebTitle = this.wkr.isShowWebTitle();
        if (typeof callback === 'function') {
          callback(showWebTitle);
        }
        return showWebTitle;
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    }
}

const wkReader = function () {
  return new WkReader();
};
export default wkReader();



// WEBPACK FOOTER //
// ./src/common/js/wkreader.js